import React, {useState, useEffect, useContext, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './dashboardfilter.css';
import styles from "./dashboardfilter.module.css";
import {store} from '../../context/store';
import { JWT } from "../../constants/local-storage";

export default function DashboardFilter({filter, setFilter}) {

	const globalState = useContext(store);

	const SELECT_ALL_OPTION = "All";

	const refFacility = useRef(null);
	const refParentSpaceType = useRef(null);
	const refSpaceType = useRef(null);
	const refParentOrganisation = useRef(null);
	const refOrganisation = useRef(null);
	const refFloor = useRef(null);
	const refSpace = useRef(null);
	const refFloorZone = useRef(null);

	const [facilities, setFacilities] = useState([]);
	const [parentSpaceTypes, setParentSpaceTypes] = useState([]);
	const [spaceTypes, setSpaceTypes] = useState([]);
	const [parentOrganisations, setParentOrganisations] = useState([]);
	const [organisations, setOrganisations] = useState([]);
	const [floors, setFloors] = useState([]);
	const [floorZones, setFloorZones] = useState([]);
	const [spaces, setSpaces] = useState([]);
	
	useEffect(function () {
	    loadFacilities();   // 🔥 ONLY THIS
	}, []);
	
	useEffect(function () {

	    if (filter.buildingId && filter.buildingId > 0) {
	        loadFloors();
	    }

	    if (filter.floorId && filter.floorId > 0) {
	        loadFloorZones();
	    }

	    if (filter.floorZoneId && filter.floorZoneId > 0) {
	        loadSpaces();
	    }

	    // these can load always (or also cascade if you want)
	    loadOrganisations();
	    loadSpaceTypes();

	}, [filter]);

	// -------------------------
	// 🔥 FILTER HANDLERS (ONLY CHANGE)
	// -------------------------

	const handleChangeParentSpaceType = (e) => {
		setFilter({...filter, parentSpaceTypeId: parseInt(e.target.value)});
	};

	const handleChangeSpaceType = (e) => {
		setFilter({...filter, spaceTypeId: parseInt(e.target.value)});
	};

	const handleChangeParentOrganisation = (e) => {
		setFilter({...filter, parentOrganisationId: parseInt(e.target.value)});
	};

	const handleChangeOrganisation = (e) => {
		setFilter({...filter, organisationId: parseInt(e.target.value)});
	};

	const handleChangeFacility = (e) => {
	    const val = parseInt(e.target.value);

	    setFloors([]);
	    setFloorZones([]);
	    setSpaces([]);

	    setFilter({
	        ...filter,
	        buildingId: val,
	        floorId: -100,
	        floorZoneId: -100,
	        spaceId: -100
	    });
	};

	const handleChangeFloor = (e) => {
		const val = parseInt(e.target.value);

		setFilter({
			...filter,
			floorId: val,
			spaceId: -100
		});
	};

	const handleChangeFloorZone = (e) => {
		const val = parseInt(e.target.value);

		setFilter({
			...filter,
			floorZoneId: val,
			spaceId: -100
		});
	};

	const handleChangeSpace = (e) => {
		setFilter({...filter, spaceId: parseInt(e.target.value)});
	};

	const handleCoreDayChange = (e) => {
		setFilter({...filter, coreDayOnly: e.target.value === "1"});
	};

	// -------------------------
	// RESET (FIXED)
	// -------------------------

	const handleReset = () => {

		setFilter({
			buildingId: -100,
			floorId: -100,
			floorZoneId: -100,
			spaceId: -100,
			parentSpaceTypeId: -100,
			spaceTypeId: -100,
			parentOrganisationId: -100,
			organisationId: -100,
			coreDayOnly: false
		});

		if (refFacility.current) refFacility.current.value = "-100";
		if (refFloor.current) refFloor.current.value = "-100";
		if (refFloorZone.current) refFloorZone.current.value = "-100";
		if (refSpace.current) refSpace.current.value = "-100";
		if (refParentSpaceType.current) refParentSpaceType.current.value = "-100";
		if (refSpaceType.current) refSpaceType.current.value = "-100";
		if (refParentOrganisation.current) refParentOrganisation.current.value = "-100";
		if (refOrganisation.current) refOrganisation.current.value = "-100";
	};

	// -------------------------
	// STYLES (UNCHANGED)
	// -------------------------

	const DARK_SELECT = {
		flexGrow: "1",
		height: "30px",
		borderRadius: "6px",
		fontSize: "12px",
		padding: "0 10px",
		outline: "none"
	};

	const DARK_OPTION = {
		color: "#1e2a38"
	};


	const mainPanelContent = {

	    display: "flex",
	    flexDirection: "column",

	    width: "calc(100% - 40px)",
	    height: "calc(100% - 40px)",

	    boxSizing: "border-box",

	    padding: "12px 18px 20px",

	    overflowY: "auto",

	    minHeight: 0

	};

	
	
	function postFilter(url, setter) {

	    const token = localStorage.getItem(JWT);

	    fetch("/resolutionsoftwareplatform/roombookingdashboard" + url, {
	        method: "POST",
	        headers: {
	            "Authorization": "Bearer " + token,   // 🔥 THIS BIT
	            "Content-Type": "application/json"
	        },
	        body: JSON.stringify(filter)
	    })
	    .then(function (res) {
	        return res.json();
	    })
	    .then(function (data) {
	        setter(data || []);
	    })
	    .catch(function (err) {
	        console.error("Filter load error:", err);
	    });
	}
	
	
	function loadFacilities() {
	    postFilter("/filter/facilities", setFacilities);
	}

	function loadFloors() {
	    postFilter("/filter/floors", setFloors);
	}

	function loadFloorZones() {
	    postFilter("/filter/floorzones", setFloorZones);
	}

	function loadSpaces() {
	    postFilter("/filter/spaces", setSpaces);
	}

	function loadOrganisations() {
	    postFilter("/filter/organisations", setOrganisations);
	}

	function loadSpaceTypes() {
	    postFilter("/filter/spacetypes", setSpaceTypes);
	}

	// -------------------------
	// RENDER (UNCHANGED)
	// -------------------------

	return (
		<div className="dashboardfilter">

			<div
			       className="dashboardfilter-glass"
			       style={mainPanelContent}
			   >

				<div className={styles.resetButton} onClick={handleReset}>
					<FontAwesomeIcon icon="sync" className={styles.resetIcon} />
					Reset
				</div>

				{/* CORE DAY */}
				<div className={styles.section} style={{paddingTop:'20px', paddingBottom:'10px'}}>
					<div className={styles.sectionTitle}>Core Day Only</div>

					<div className={styles.radioRow}>
						<label style={{display:'flex', alignItems:'center', gap:'6px', cursor:'pointer'}}>
							<input
								type="radio"
								name="coreday"
								value="0"
								checked={!filter.coreDayOnly}
								onChange={handleCoreDayChange}
							/>
							<span style={{color:'rgba(255,255,255,0.85)', fontSize:'12px'}}>No</span>
						</label>

						<label style={{display:'flex', alignItems:'center', gap:'6px', cursor:'pointer'}}>
							<input
								type="radio"
								name="coreday"
								value="1"
								checked={filter.coreDayOnly}
								onChange={handleCoreDayChange}
							/>
							<span style={{color:'rgba(255,255,255,0.85)', fontSize:'12px'}}>Yes</span>
						</label>
					</div>
				</div>
				
				
				<div className={styles.sectionRow}>
				    <div className={styles.sectionTitle}>Organisation</div>
				    <select
				        style={DARK_SELECT}
				        ref={refOrganisation}
				        className={styles.select}
				        onChange={handleChangeOrganisation}
				    >
				        <option style={DARK_OPTION} value="-100">{SELECT_ALL_OPTION}</option>
				        {organisations.map(function (item) {
				            return (
				                <option key={item.id} value={item.id}>
				                    {item.name}
				                </option>
				            );
				        })}
				    </select>
				</div>
				
				
				<div className={styles.sectionRow}>
				    <div className={styles.sectionTitle}>Space Type</div>
				    <select
				        style={DARK_SELECT}
				        ref={refSpaceType}
				        className={styles.select}
				        onChange={handleChangeSpaceType}
				    >
				        <option style={DARK_OPTION} value="-100">{SELECT_ALL_OPTION}</option>
				        {spaceTypes.map(function (item) {
				            return (
				                <option key={item.id} value={item.id}>
				                    {item.name}
				                </option>
				            );
				        })}
				    </select>
				</div>

				{/* BUILDING */}
				<div className={styles.sectionRow}>
					<div className={styles.sectionTitle}>Building</div>
					<select style={DARK_SELECT} ref={refFacility} className={styles.select} onChange={handleChangeFacility}>
						<option style={DARK_OPTION} value="-100">{SELECT_ALL_OPTION}</option>
						{facilities.map((item) => (
							<option style={DARK_OPTION} key={item.id} value={item.id}>{item.name}</option>
						))}
					</select>
				</div>

				{/* FLOOR */}
				<div className={styles.sectionRow}>
					<div className={styles.sectionTitle}>Floor</div>
					<select style={DARK_SELECT} ref={refFloor} className={styles.select} onChange={handleChangeFloor}>
						<option style={DARK_OPTION} value="-100">Select</option>
						{floors.map((item) => (
							<option style={DARK_OPTION} key={item.id} value={item.id}>{item.name}</option>
						))}
					</select>
				</div>

				{/* FLOOR ZONE */}
				<div className={styles.sectionRow}>
					<div className={styles.sectionTitle}>Floor Zone</div>
					<select style={DARK_SELECT} ref={refFloorZone} className={styles.select} onChange={handleChangeFloorZone}>
						<option value="-100">Select</option>
						{floorZones.map((item) => (
							<option style={DARK_OPTION} key={item.id} value={item.id}>{item.name}</option>
						))}
					</select>
				</div>

				{/* SPACE */}
				<div className={styles.sectionRow}>
					<div className={styles.sectionTitle}>Work Setting</div>
					<select style={DARK_SELECT} ref={refSpace} className={styles.select} onChange={handleChangeSpace}>
						<option style={DARK_OPTION} value="-100">Select</option>
						{spaces.map((item) => (
							<option style={DARK_OPTION} key={item.id} value={item.id}>{item.code}</option>
						))}
					</select>
				</div>

			</div>
		</div>
	);
}